document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector('.lp-airstyle-video-list');
    const isEnableSwiper = container.getAttribute('data-swiper-m') === 'true';
    const swiperContainers = container.querySelectorAll('.category-container.swiper-container');
    swiperContainers.forEach(wrapper => {
        // 将弹窗从swiper里面搬到swiper外面，恢复弹窗的fixed参考是窗口
        const videoModalList = wrapper.nextElementSibling;
        const videoModals = wrapper.querySelectorAll('.product-media-video-container');
        // videoModalList.appendChild(videoModals);
        videoModals.forEach(modal => {
            videoModalList.appendChild(modal);
        })
    })
    if (window.innerWidth <= 850 && isEnableSwiper) {
        const swiperSettings = JSON.parse(container.getAttribute('data-swiper-settings'));
        swiperContainers.forEach(wrapper => {
            // 创建swiper
            const swiper = new Swiper(wrapper, swiperSettings);

        })


    } else {
        return;
    }

})